import React from 'react';

const LoadingSpinner = () => (
  <div className="text-center py-4">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
  </div>
);

export default LoadingSpinner;